import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { monoSx, KeyValue, RawJsonAccordion } from '../../../../helperComponents/showPrimitives';

const ColumnsMapTable = ({ columns }) => {
  const entries = Object.entries(columns || {});
  if (!entries.length) return <Typography sx={{ fontFamily: 'monospace' }}>none</Typography>;

  return (
    <Table size="small" sx={{ maxWidth: 800 }}>
      <TableHead>
        <TableRow>
          <TableCell>Google field</TableCell>
          <TableCell>Table column</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {entries.map(([field, column]) => (
          <TableRow key={field}>
            <TableCell>{field}</TableCell>
            <TableCell>{column}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const isPresent = (value) => value !== undefined && value !== null;

const OptionalLine = ({ label, value }) => {
  if (!isPresent(value)) return null;
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Box component="pre" sx={monoSx}>{JSON.stringify(value)}</Box>
    </Box>
  );
};

export const JobConfig = ({ record }) => {
  const config = record.config || {};
  const isLegacy = record.type === 'legacy_csv';
  const windowText = config.snapshot ? 'snapshot' : String(config.window_days ?? '');

  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, p: 3, mb: 2 }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>Config</Typography>
      <Grid container spacing={2}>
        {isLegacy && <KeyValue label="Report">{config.report}</KeyValue>}
        <KeyValue label="Target table">{config.target}</KeyValue>
        <KeyValue label="Window days">{windowText}</KeyValue>
        {!isLegacy && <KeyValue label="Mode">{config.mode}</KeyValue>}
        {!isLegacy && (
          <KeyValue label="Conflict">{Array.isArray(config.conflict) ? config.conflict.join(', ') : ''}</KeyValue>
        )}
      </Grid>

      {isLegacy ? (
        <Box sx={{ bgcolor: 'grey.50', borderRadius: 2, p: 2, mt: 2, display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <InfoOutlinedIcon fontSize="small" color="action" />
          <Typography color="text.secondary">
            Legacy CSV job. GAQL fields do not apply: columns, conflict, mode, JSON columns, array columns, constants, data fields.
          </Typography>
        </Box>
      ) : (
        <>
          {config.gaql && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">Query</Typography>
              <Box component="pre" sx={{ ...monoSx, bgcolor: 'grey.50', borderRadius: 2, p: 2 }}>{config.gaql}</Box>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary">Columns</Typography>
            <ColumnsMapTable columns={config.columns} />
          </Box>
          <OptionalLine label="JSON columns" value={config.json_columns} />
          <OptionalLine label="Array columns" value={config.array_columns} />
          <OptionalLine label="Constants" value={config.constants} />
          <OptionalLine label="Data fields" value={config.data_fields} />
        </>
      )}

      <RawJsonAccordion value={record.config} />
    </Paper>
  );
};
